import { render, staticRenderFns } from "./CreatePrices.vue?vue&type=template&id=18676c18&"
import script from "./CreatePrices.vue?vue&type=script&lang=js&"
export * from "./CreatePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports